import { format, formatDistanceToNowStrict, intervalToDuration } from 'date-fns';

export enum Months {
  January = 'January',
  February = 'February',
  March = 'March',
  April = 'April',
  May = 'May',
  June = 'June',
  July = 'July',
  August = 'August',
  September = 'September',
  October = 'October',
  November = 'November',
  December = 'December',
}

export const MONTHS = [
  Months.January,
  Months.February,
  Months.March,
  Months.April,
  Months.May,
  Months.June,
  Months.July,
  Months.August,
  Months.September,
  Months.October,
  Months.November,
  Months.December,
];

export const monthsValues: Record<Months, number> = {
  [Months.January]: 1,
  [Months.February]: 2,
  [Months.March]: 3,
  [Months.April]: 4,
  [Months.May]: 5,
  [Months.June]: 6,
  [Months.July]: 7,
  [Months.August]: 8,
  [Months.September]: 9,
  [Months.October]: 10,
  [Months.November]: 11,
  [Months.December]: 12,
};

// get list of years from current year minus a variable value
export const getYearsFromNowList = (years = 40): string[] => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: years }, (_, i) => (currentYear - i).toString());
};

export const formatDateDistance = (hireDate: Date): string => {
  const { years, months } = intervalToDuration({
    start: hireDate,
    end: Date.now(),
  });

  if (years === 0) return formatDistanceToNowStrict(hireDate);

  if (months === 0) return `${years} ${years === 1 ? 'year' : 'years'}`;

  return `${years} ${years === 1 ? 'year' : 'years'} & ${months} ${
    months === 1 ? 'month' : 'months'
  }`;
};

export const isSameDate = (a: Date, b: Date): boolean => {
  return (
    a.getDate() === b.getDate() &&
    a.getMonth() === b.getMonth() &&
    a.getFullYear() === b.getFullYear()
  );
};

export const compareDateByDay = (a: Date, b: Date): number => {
  if (isSameDate(a, b)) return 0;
  return a.getTime() - b.getTime();
};

export const getFormatedDate = (date: Date): string => format(date, 'MM/dd/yyyy');

const getYearLabel = (date: Date): string => {
  const currentYear = new Date().getFullYear();
  return date.getFullYear() !== currentYear ? `, ${date.getFullYear()}` : '';
};

export const formatDateInterval = (a: Date, b: Date, pattern: string): string => {
  if (isSameDate(a, b)) {
    return `${format(a, pattern)}${getYearLabel(a)}`;
  }

  return `${format(a, pattern)}${getYearLabel(a)} - ${format(b, pattern)}${getYearLabel(b)}`;
};

export const makeDateWithCurrentTime = (isoDate: string): Date => {
  const year = parseInt(isoDate.substring(0, 4), 10);
  const month = parseInt(isoDate.substring(5, 7), 10);
  const day = parseInt(isoDate.substring(8, 10), 10);

  const date = new Date();
  date.setFullYear(year, month - 1, day);
  return date;
};

export const isTodayOrTomorrow = (date: Date): 'today' | 'tomorrow' | undefined => {
  const today = new Date();
  if (isSameDate(date, today)) return 'today';

  today.setDate(today.getDate() + 1);
  if (isSameDate(date, today)) return 'tomorrow';

  return undefined;
};

export const formatDateToShortFormat = (date: Date): string =>
  format(new Date(date), 'MMM d, yyyy');
